export const darkTheme: Record<string, string> = {
  primary: '#F7A163',
  secondary: '#E3E3E3',
  tertiary: '#ACACAC',
  background: '#171717',
  bodyColor: '#fff',
  textReverse: '#000',
  headerBorder: '#2F2F2F',
  badgeBackground: '#212121',
  trustLabelsBg: '#271D16',
  optionsBg: '#212121',
  stepBorder: '#F58A3C',
  storeBg: '#422006',
  storeBorder: '#854D0E',
  marketBg: '#5E5E5E',
  modalBorder: '#623718',
  googleBtnBg: '#131314',
  googleBtnBorder: '#8E918F',
  reviewBorder: '#464646',
  timerBg: '#C13737',
};
